import {NodePropertiesPane} from '../../SidePanel/RightPanel/NodePane.jsx'
import Version from '../components/PropertiesControllerVersion/PropertiesControllerVersion.jsx'

const PropertiesPaneCatData = (props) => (
    <NodePropertiesPane {...props}>
        <Version label="部署模型版本" />
    </NodePropertiesPane>
)

export default PropertiesPaneCatData
